import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosolapurcab() {



    const cardData = {

keyword: "Mumbai to Solapur Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Solapur Cab services for one-way trips, round trips, business travel, family tours, and pilgrimage journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra routes, we ensure a smooth, comfortable, and hassle-free travel experience to Solapur.",

topPlaces: [
    {
        title: "Shri Siddheshwar Temple",
        description:
            "Shri Siddheshwar Temple is the most important pilgrimage site in Solapur dedicated to Lord Shiva, located on an island in Siddheshwar Lake and visited by thousands of devotees."
    },
    {
        title: "Great Indian Bustard Sanctuary (Nannaj)",
        description:
            "Located near Solapur, this sanctuary is home to the rare Great Indian Bustard and other wildlife species, making it an important eco-tourism destination."
    },
    {
        title: "Bhuikot Fort",
        description:
            "Bhuikot Fort is a historic fort in Solapur known for its ancient architecture, gardens, and cultural significance from the Bahmani and Adil Shahi periods."
    },
    {
        title: "Solapur Science Centre",
        description:
            "The Science Centre is a popular educational attraction featuring interactive exhibits, space displays, and learning activities for children and families."
    },
    {
        title: "Hipparga Lake",
        description:
            "Hipparga Lake is a peaceful water reservoir near Solapur offering scenic views and a relaxing environment for visitors and nature lovers."
    },
    {
        title: "Akkalkot Swami Samarth Temple",
        description:
            "Akkalkot, located near Solapur, is a major spiritual destination dedicated to Shri Swami Samarth Maharaj and attracts devotees throughout the year."
    },
    {
        title: "Pandharpur (Nearby Pilgrimage Route)",
        description:
            "Pandharpur is one of Maharashtra’s most sacred pilgrimage destinations dedicated to Lord Vitthal, often included in extended travel plans from Solapur."
    },
    {
        title: "Siddheshwar Lake Garden",
        description:
            "The lake garden around Siddheshwar Temple offers walking paths, greenery, and peaceful surroundings for families visiting Solapur."
    },
    {
        title: "Solapur Textile Market Area",
        description:
            "Solapur is famous for its textile industry and chadar markets, making it a key commercial hub in Maharashtra."
    },
    {
        title: "Hotgi Road Region",
        description:
            "Hotgi Road is a developing area in Solapur known for connectivity, residential zones, and industrial growth."
    }
],



services: [
{
name: "Mumbai to Solapur Cab",
description: "Mumbai Airport Cab offers Mumbai to Solapur Cab service for safe, comfortable, and reliable long-distance travel within Maharashtra. Whether you are travelling for business, family visits, education, medical needs, tourism, or relocation, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our professional chauffeurs ensure smooth highway driving, punctual pickup, passenger safety, and stress-free journey experience. With doorstep pickup from Mumbai, flexible travel plans, transparent pricing, luggage assistance, and 24x7 support, we make your intercity travel comfortable and convenient."
},
{
name: "Mumbai to Solapur Taxi",
description: "Mumbai to Solapur Taxi service by Mumbai Airport Cab provides dependable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for families, corporate travellers, and solo passengers, we ensure safe highway travel, timely pickup, and comfortable seating for a smooth journey from Mumbai to Solapur."
},
{
name: "Mumbai to Solapur Cab Fare",
description: "Mumbai to Solapur Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We offer clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective travel with comfort and reliability."
},
{
name: "Mumbai to Solapur Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Solapur Car Rental service with chauffeur-driven vehicles for long-distance travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family trips, corporate travel, and personal journeys. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Solapur One Way Cab",
description: "Mumbai to Solapur One Way Cab service provides affordable travel for passengers who require a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for intercity travel, relocation, and business trips."
},
{
name: "Mumbai to Solapur Outstation Cab",
description: "Mumbai to Solapur Outstation Cab service offers reliable long-distance transportation with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free intercity journeys."
},
{
name: "Mumbai to Solapur Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Solapur Taxi Service with professional chauffeurs, clean vehicles, and 24x7 availability. We ensure punctual pickup, smooth highway travel, and reliable transportation for all types of passengers."
},
{
name: "Mumbai to Solapur Long Distance Cab",
description: "Mumbai to Solapur Long Distance Cab service is designed for extended highway journeys with maximum comfort and safety. Mumbai Airport Cab provides experienced drivers, air-conditioned vehicles, luggage assistance, and smooth travel planning for stress-free long trips."
},
{
name: "Mumbai to Solapur Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Solapur Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality, making long-distance journeys more relaxing and convenient."
},
{
name: "Mumbai to Solapur SUV Cab",
description: "Mumbai to Solapur SUV Cab service provides powerful and comfortable vehicles suitable for highway travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups travelling together."
},
{
name: "Mumbai to Solapur Family Cab",
description: "Mumbai to Solapur Family Cab service provides safe and comfortable transportation for families travelling together. Mumbai Airport Cab ensures spacious vehicles, experienced drivers, luggage-friendly travel, and flexible booking options for a stress-free journey."
},
{
name: "Mumbai to Solapur Round Trip Cab",
description: "Mumbai to Solapur Round Trip Cab service offers complete return journey solutions for business trips, family visits, tourism, and personal travel. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Solapur Business Cab",
description: "Mumbai to Solapur Business Cab service is designed for corporate professionals requiring reliable transportation for meetings, office visits, and business engagements. Mumbai Airport Cab ensures punctual service, executive comfort, and professional chauffeurs for productive travel."
},
{
name: "Mumbai to Solapur Highway Cab",
description: "Mumbai to Solapur Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides experienced chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Solapur Budget Cab",
description: "Mumbai to Solapur Budget Cab service offers economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective long-distance travel."
},
{
name: "Mumbai to Solapur Express Cab",
description: "Mumbai to Solapur Express Cab service provides fast and efficient transportation for urgent travel needs. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival at your destination."
},
{
name: "Mumbai to Solapur Night Travel Cab",
description: "Mumbai to Solapur Night Travel Cab service provides safe and reliable overnight transportation for long-distance travellers. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
},
{
name: "Mumbai to Solapur Travel Service",
description: "Mumbai to Solapur Travel Service provides complete transportation solutions for families, business travellers, and tourists. Mumbai Airport Cab ensures safe, comfortable, and well-organized intercity travel with flexible itineraries and professional drivers."
},
{
name: "Mumbai to Solapur Tour Cab",
description: "Mumbai to Solapur Tour Cab service offers customized travel solutions for sightseeing and leisure trips. Mumbai Airport Cab ensures comfortable vehicles, flexible schedules, and reliable service for a smooth travel experience."
}
],

tableData: [
["Mumbai to Solapur Cab","Mumbai to Solapur Taxi"],
["Mumbai to Solapur Cab Fare","Mumbai to Solapur Car Rental"],
["Mumbai to Solapur One Way Cab","Mumbai to Solapur Outstation Cab"],
["Mumbai to Solapur Taxi Service","Mumbai to Solapur Long Distance Cab"],
["Mumbai to Solapur Innova Cab","Mumbai to Solapur SUV Cab"],
["Mumbai to Solapur Family Cab","Mumbai to Solapur Round Trip Cab"],
["Mumbai to Solapur Business Cab","Mumbai to Solapur Highway Cab"],
["Mumbai to Solapur Budget Cab","Mumbai to Solapur Express Cab"]
],

















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Solapur Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Solapur Cab services for business travelers, families, pilgrims, students, and tourists seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Convenient Travel Between Mumbai and Solapur",
        WhyChoosedescription: "Our cab service offers hassle-free connectivity for family visits, corporate travel, educational purposes, religious tours, and personal journeys between Mumbai and Solapur."
    },
    {
        WhyChooseheading: "Perfect for Business and Industrial Travel",
        WhyChoosedescription: "Solapur is an important commercial and industrial city, making our cab service ideal for business meetings, factory visits, corporate assignments, and official travel."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you need a one-way transfer, same-day return, round trip, or customized travel itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance highway routes and ensure safe, smooth, and comfortable transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Pilgrims, and Groups",
        WhyChoosedescription: "From solo travelers and families to pilgrimage groups and corporate teams, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Solapur Cabs?",
        answer: "Solapur attracts travelers for business purposes, family visits, educational activities, industrial work, and religious tourism."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Solapur?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Solapur travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide same-day return trips?",
        answer: "Yes, customers can choose same-day return journeys depending on their travel schedule and requirements."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many business professionals, industrial visitors, and corporate clients use our Mumbai to Solapur Cab services regularly."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, educational trips, and tour groups."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can multiple stops be included during the trip?",
        answer: "Yes, customers can customize their itinerary and include sightseeing points, temples, business locations, restaurants, and personal stops."
    },
    {
        question: "Is advance booking recommended for Mumbai to Solapur travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning."
    },
    {
        question: "How can I book a Mumbai to Solapur Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Santosh Kulkarni",
        feedback:
            "I frequently travel between Mumbai and Solapur for business purposes. Mumbai Airport Cabs consistently provides punctual service, comfortable vehicles, and professional drivers.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anagha Patwardhan",
        feedback:
            "Our family trip to Solapur was very comfortable and well managed. The vehicle was spacious, the driver was courteous, and the entire journey was smooth from start to finish.",
        rating: 5
    }
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Solapur Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-solapur-cab.jpg",
"description": "Book Mumbai to Solapur cab service for long-distance outstation travel, business trips, and family journeys. Mumbai Airport Cabs offers reliable one-way and round-trip taxi service with professional drivers, comfortable cars including sedans and SUVs, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-solapur-cab"
}
};





    return (
        <div>


<Helmet>
  <title>Mumbai to Solapur Cab | Outstation Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Solapur cab for outstation travel, business trips, and family journeys. Safe and comfortable long-distance taxi service with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to solapur cab, mumbai to solapur taxi, mumbai to solapur cab fare, mumbai to solapur car rental, mumbai to solapur one way cab, mumbai to solapur outstation cab, mumbai to solapur long distance cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitosolapurcab;